import { createReducer } from 'reduxsauce';
import { produce } from 'immer';
import concat from 'ramda/src/concat';
import findIndex from 'ramda/src/findIndex';
import propEq from 'ramda/src/propEq';
import remove from 'ramda/src/remove';
import { CompanyTypes } from '~/actions';
import { removeStatus } from '~/services/util';

const initialState = {
    status: [],
    business: [],
    employees: {},
    businessCompany: {},
    blogCategories: [],
    topicCategories: [],
    companyUsers: [],
    subscriptions: [],
    subscriptionReports: [],
};

const getbusinessRequest = produce((draft, action) => {
    const { loading = true } = action;
    if (loading) draft.status.push('pending-cbs');
});
const getbusinessSuccess = produce((draft, action) => {
    draft.status = removeStatus('pending-cbs', draft.status);
    const business = action.response[0];
    const idx = findIndex(propEq('id', business.id), draft.business);
    if (idx > -1) {
        draft.business[idx] = business;
    } else {
        draft.business = concat(draft.business, action.response);
    }
});
const getbusinessFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-cbs', draft.status);
});

const postbusinessRequest = produce((draft, action) => {
    draft.status.push('pending-cpb');
});
const postbusinessSuccess = produce((draft, action) => {
    draft.status = removeStatus('pending-cpb', draft.status);
});
const postbusinessFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-cpb', draft.status);
});

const getbusinessblogRequest = produce((draft, action) => {
    const { loading = true } = action;
    if (loading) draft.status.push('pending-cbb');
});
const getbusinessblogSuccess = produce((draft, action) => {
    const { businessId, data } = action.response;
    const idx = findIndex(propEq('id', businessId), draft.business);
    if (idx > -1) {
        draft.business[idx] = {
            ...draft.business[idx],
            vrs: { ...draft.business[idx]?.vrs, blog: { ...draft.business[idx]?.vrs?.blog, data } },
        };
    }
    draft.status = removeStatus('pending-cbb', draft.status);
});
const getbusinessblogFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-cbb', draft.status);
});

const getbzcompanyRequest = produce((draft, action) => {
    draft.status.push('pending-cgc');
});
const getbzcompanySuccess = produce((draft, action) => {
    draft.status = removeStatus('pending-cgc', draft.status);
    draft.businessCompany = action.response;
});
const getbzcompanyFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-cgc', draft.status);
});

const savebzcompanyRequest = produce((draft, action) => {
    draft.status.push('pending-csb');
});
const savebzcompanySuccess = produce((draft, action) => {
    draft.status = removeStatus('pending-csb', draft.status);
    draft.business = concat(draft.business, [action.response]);
});
const savebzcompanyFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-csb', draft.status);
});

const savebusinessRequest = produce((draft, action) => {
    draft.status.push('pending-cscb');
});
const savebusinessSuccess = produce((draft, action) => {
    draft.status = removeStatus('pending-cscb', draft.status);
    draft.businessCompany = action.response;
});
const savebusinessFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-cscb', draft.status);
});
const getblogcategoriesRequest = produce((draft, action) => {});
const getblogcategoriesSuccess = produce((draft, action) => {
    draft.blogCategories = action.response;
});
const getblogcategoriesFailure = produce((draft, action) => {});
const gettopiccategoriesRequest = produce((draft, action) => {
    draft.status.push('pending-ctc');
});
const gettopiccategoriesSuccess = produce((draft, action) => {
    draft.status = removeStatus('pending-ctc', draft.status);
    draft.topicCategories = action.response;
});
const gettopiccategoriesFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-ctc', draft.status);
});

const getcompanyusersRequest = produce((draft, action) => {
    draft.status.push('pending-cuc');
});
const getcompanyusersSuccess = produce((draft, action) => {
    draft.status = removeStatus('pending-cuc', draft.status);
    draft.companyUsers = action.response;
});
const getcompanyusersFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-cuc', draft.status);
});

const postregisterbusinessuserRequest = produce((draft, action) => {
    draft.status.push('pending-cru');
});
const postregisterbusinessuserSuccess = produce((draft, action) => {
    draft.status = removeStatus('pending-cru', draft.status);
});
const postregisterbusinessuserFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-cru', draft.status);
});

const postaddeditdepartmentsRequest = produce((draft, action) => {
    draft.status.push('pending-cad');
});
const postaddeditdepartmentsSuccess = produce((draft, action) => {
    draft.status = removeStatus('pending-cad', draft.status);
});
const postaddeditdepartmentsFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-cad', draft.status);
});

const postaddeditteamsRequest = produce((draft, action) => {
    draft.status.push('pending-cet');
});
const postaddeditteamsSuccess = produce((draft, action) => {
    draft.status = removeStatus('pending-cet', draft.status);
});
const postaddeditteamsFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-cet', draft.status);
});

const postdeleteteamRequest = produce((draft, action) => {
    draft.status.push('pending-pdt');
});
const postdeleteteamSuccess = produce((draft, action) => {
    draft.status = removeStatus('pending-pdt', draft.status);
});
const postdeleteteamFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-pdt', draft.status);
});

const postsavejobrolesRequest = produce((draft, action) => {
    draft.status.push('pending-csj');
});
const postsavejobrolesSuccess = produce((draft, action) => {
    draft.status = removeStatus('pending-csj', draft.status);
});
const postsavejobrolesFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-csj', draft.status);
});

const postsavehcmcompanyRequest = produce((draft, action) => {
    draft.status.push('pending-csh');
});
const postsavehcmcompanySuccess = produce((draft, action) => {
    draft.status = removeStatus('pending-csh', draft.status);
});
const postsavehcmcompanyFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-csh', draft.status);
});

const getminimalcompanyemployeesRequest = produce((draft, action) => {
    draft.status.push('pending-mcce');
});
const getminimalcompanyemployeesSuccess = produce((draft, action) => {
    draft.status = removeStatus('pending-mcce', draft.status);
    const { response: employees, cacheBust } = action;
    if (cacheBust === 1) {
        employees?.forEach((item, index) => {
            const temp = { ...item };
            delete temp.extra;
            draft.employees[employees[0].company_id][index] = { ...draft.employees[employees[0].company_id][index], ...temp };
        });
    } else {
        draft.employees[employees[0].company_id] = employees;
    }
});
const getminimalcompanyemployeesFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-mcce', draft.status);
});

const postcompanyfollowRequest = produce((draft, action) => {
    draft.status.push('pending-ccf');
});
const postcompanyfollowSuccess = produce((draft, action) => {
    draft.status = removeStatus('pending-ccf', draft.status);
});
const postcompanyfollowFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-ccf', draft.status);
});

const postcompanyconnectRequest = produce((draft, action) => {
    draft.status.push('pending-ccc');
});
const postcompanyconnectSuccess = produce((draft, action) => {
    draft.status = removeStatus('pending-ccc', draft.status);
});
const postcompanyconnectFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-ccc', draft.status);
});

const getcompanyconnectionsRequest = produce((draft, action) => {
    draft.status.push('pending-ccr');
});
const getcompanyconnectionsSuccess = produce((draft, action) => {
    const { companyId, connections } = action.response;
    const idx = draft.business.findIndex((business) => business.vrs.id === companyId);
    draft.business[idx].vrs = { ...draft.business[idx].vrs, connections };

    draft.status = removeStatus('pending-ccr', draft.status);
});
const getcompanyconnectionsFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-ccr', draft.status);
});

const postdeletedepartmentRequest = produce((draft, action) => {
    draft.status.push('pending-cdd');
});
const postdeletedepartmentSuccess = produce((draft, action) => {
    const { businessId, departmentId } = action.response;
    const idx = findIndex(propEq('id', businessId), draft.business);
    const business = draft.business[idx];
    const did = findIndex(propEq('id', departmentId), business.hcms?.departments || []);
    if (did > -1) {
        const departments = remove(did, 1, business.hcms?.departments);
        business.hcms.departments = departments;
        draft.business[idx] = business;
    }
    draft.status = removeStatus('pending-cdd', draft.status);
});
const postdeletedepartmentFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-cdd', draft.status);
});

const getusersubscriptionsRequest = produce((draft, action) => {
    const { loading = true } = action;
    if (loading) draft.status.push('pending-gus');
});
const getusersubscriptionsSuccess = produce((draft, action) => {
    const { subscriptions } = action.response;
    draft.subscriptions = subscriptions;
    draft.status = removeStatus('pending-gus', draft.status);
});
const getusersubscriptionsFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-gus', draft.status);
});

const getsubscriptionreportsRequest = produce((draft, action) => {
    const { loading = true } = action;
    if (loading) draft.status.push('pending-ssr');
});
const getsubscriptionreportsSuccess = produce((draft, action) => {
    const { subscription_reports } = action.response;
    draft.subscriptionReports = subscription_reports;
    draft.status = removeStatus('pending-ssr', draft.status);
});
const getsubscriptionreportsFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-ssr', draft.status);
});

const getsubscriptionfrequenciesRequest = produce((draft, action) => {
    const { loading = true } = action;
    if (loading) draft.status.push('pending-ssf');
});
const getsubscriptionfrequenciesSuccess = produce((draft, action) => {
    draft.status = removeStatus('pending-ssf', draft.status);
});
const getsubscriptionfrequenciesFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-ssf', draft.status);
});

const postaddsubscriptionRequest = produce((draft, action) => {
    const { loading = true } = action;
    if (loading) draft.status.push('pending-pas');
});
const postaddsubscriptionSuccess = produce((draft, action) => {
    draft.status = removeStatus('pending-pas', draft.status);
});
const postaddsubscriptionFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-pas', draft.status);
});

const postsavesubscriptionRequest = produce((draft, action) => {
    const { loading = true } = action;
    if (loading) draft.status.push('pending-pss');
});
const postsavesubscriptionSuccess = produce((draft, action) => {
    draft.status = removeStatus('pending-pss', draft.status);
});
const postsavesubscriptionFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-pss', draft.status);
});

const setbzcompanyRequest = produce((draft, action) => {
    draft.businessCompany = action.company;
});

const resetRequest = produce((draft) => {
    draft.status = [];
});

const clearRequest = produce((draft, action) => (draft = initialState));

export const reducer = createReducer(initialState, {
    [CompanyTypes.GETBUSINESS_REQUEST]: getbusinessRequest,
    [CompanyTypes.GETBUSINESS_SUCCESS]: getbusinessSuccess,
    [CompanyTypes.GETBUSINESS_FAILURE]: getbusinessFailure,

    [CompanyTypes.POSTBUSINESS_REQUEST]: postbusinessRequest,
    [CompanyTypes.POSTBUSINESS_SUCCESS]: postbusinessSuccess,
    [CompanyTypes.POSTBUSINESS_FAILURE]: postbusinessFailure,

    [CompanyTypes.GETBUSINESSBLOG_REQUEST]: getbusinessblogRequest,
    [CompanyTypes.GETBUSINESSBLOG_SUCCESS]: getbusinessblogSuccess,
    [CompanyTypes.GETBUSINESSBLOG_FAILURE]: getbusinessblogFailure,

    [CompanyTypes.GETBZCOMPANY_REQUEST]: getbzcompanyRequest,
    [CompanyTypes.GETBZCOMPANY_SUCCESS]: getbzcompanySuccess,
    [CompanyTypes.GETBZCOMPANY_FAILURE]: getbzcompanyFailure,

    [CompanyTypes.SAVEBZCOMPANY_REQUEST]: savebzcompanyRequest,
    [CompanyTypes.SAVEBZCOMPANY_SUCCESS]: savebzcompanySuccess,
    [CompanyTypes.SAVEBZCOMPANY_FAILURE]: savebzcompanyFailure,

    [CompanyTypes.SAVEBUSINESS_REQUEST]: savebusinessRequest,
    [CompanyTypes.SAVEBUSINESS_SUCCESS]: savebusinessSuccess,
    [CompanyTypes.SAVEBUSINESS_FAILURE]: savebusinessFailure,

    [CompanyTypes.GETBLOGCATEGORIES_REQUEST]: getblogcategoriesRequest,
    [CompanyTypes.GETBLOGCATEGORIES_SUCCESS]: getblogcategoriesSuccess,
    [CompanyTypes.GETBLOGCATEGORIES_FAILURE]: getblogcategoriesFailure,

    [CompanyTypes.GETTOPICCATEGORIES_REQUEST]: gettopiccategoriesRequest,
    [CompanyTypes.GETTOPICCATEGORIES_SUCCESS]: gettopiccategoriesSuccess,
    [CompanyTypes.GETTOPICCATEGORIES_FAILURE]: gettopiccategoriesFailure,

    [CompanyTypes.GETCOMPANYUSERS_REQUEST]: getcompanyusersRequest,
    [CompanyTypes.GETCOMPANYUSERS_SUCCESS]: getcompanyusersSuccess,
    [CompanyTypes.GETCOMPANYUSERS_FAILURE]: getcompanyusersFailure,

    [CompanyTypes.POSTREGISTERBUSINESSUSER_REQUEST]: postregisterbusinessuserRequest,
    [CompanyTypes.POSTREGISTERBUSINESSUSER_SUCCESS]: postregisterbusinessuserSuccess,
    [CompanyTypes.POSTREGISTERBUSINESSUSER_FAILURE]: postregisterbusinessuserFailure,

    [CompanyTypes.POSTADDEDITDEPARTMENTS_REQUEST]: postaddeditdepartmentsRequest,
    [CompanyTypes.POSTADDEDITDEPARTMENTS_SUCCESS]: postaddeditdepartmentsSuccess,
    [CompanyTypes.POSTADDEDITDEPARTMENTS_FAILURE]: postaddeditdepartmentsFailure,

    [CompanyTypes.POSTADDEDITTEAMS_REQUEST]: postaddeditteamsRequest,
    [CompanyTypes.POSTADDEDITTEAMS_SUCCESS]: postaddeditteamsSuccess,
    [CompanyTypes.POSTADDEDITTEAMS_FAILURE]: postaddeditteamsFailure,

    [CompanyTypes.POSTDELETETEAM_REQUEST]: postdeleteteamRequest,
    [CompanyTypes.POSTDELETETEAM_SUCCESS]: postdeleteteamSuccess,
    [CompanyTypes.POSTDELETETEAM_FAILURE]: postdeleteteamFailure,

    [CompanyTypes.POSTSAVEJOBROLES_REQUEST]: postsavejobrolesRequest,
    [CompanyTypes.POSTSAVEJOBROLES_SUCCESS]: postsavejobrolesSuccess,
    [CompanyTypes.POSTSAVEJOBROLES_FAILURE]: postsavejobrolesFailure,

    [CompanyTypes.POSTSAVEHCMCOMPANY_REQUEST]: postsavehcmcompanyRequest,
    [CompanyTypes.POSTSAVEHCMCOMPANY_SUCCESS]: postsavehcmcompanySuccess,
    [CompanyTypes.POSTSAVEHCMCOMPANY_FAILURE]: postsavehcmcompanyFailure,

    [CompanyTypes.GETMINIMALCOMPANYEMPLOYEES_REQUEST]: getminimalcompanyemployeesRequest,
    [CompanyTypes.GETMINIMALCOMPANYEMPLOYEES_SUCCESS]: getminimalcompanyemployeesSuccess,
    [CompanyTypes.GETMINIMALCOMPANYEMPLOYEES_FAILURE]: getminimalcompanyemployeesFailure,

    [CompanyTypes.POSTCOMPANYFOLLOW_REQUEST]: postcompanyfollowRequest,
    [CompanyTypes.POSTCOMPANYFOLLOW_SUCCESS]: postcompanyfollowSuccess,
    [CompanyTypes.POSTCOMPANYFOLLOW_FAILURE]: postcompanyfollowFailure,

    [CompanyTypes.POSTCOMPANYCONNECT_REQUEST]: postcompanyconnectRequest,
    [CompanyTypes.POSTCOMPANYCONNECT_SUCCESS]: postcompanyconnectSuccess,
    [CompanyTypes.POSTCOMPANYCONNECT_FAILURE]: postcompanyconnectFailure,

    [CompanyTypes.GETCOMPANYCONNECTIONS_REQUEST]: getcompanyconnectionsRequest,
    [CompanyTypes.GETCOMPANYCONNECTIONS_SUCCESS]: getcompanyconnectionsSuccess,
    [CompanyTypes.GETCOMPANYCONNECTIONS_FAILURE]: getcompanyconnectionsFailure,

    [CompanyTypes.POSTDELETEDEPARTMENT_REQUEST]: postdeletedepartmentRequest,
    [CompanyTypes.POSTDELETEDEPARTMENT_SUCCESS]: postdeletedepartmentSuccess,
    [CompanyTypes.POSTDELETEDEPARTMENT_FAILURE]: postdeletedepartmentFailure,

    [CompanyTypes.GETUSERSUBSCRIPTIONS_REQUEST]: getusersubscriptionsRequest,
    [CompanyTypes.GETUSERSUBSCRIPTIONS_SUCCESS]: getusersubscriptionsSuccess,
    [CompanyTypes.GETUSERSUBSCRIPTIONS_FAILURE]: getusersubscriptionsFailure,

    [CompanyTypes.GETSUBSCRIPTIONREPORTS_REQUEST]: getsubscriptionreportsRequest,
    [CompanyTypes.GETSUBSCRIPTIONREPORTS_SUCCESS]: getsubscriptionreportsSuccess,
    [CompanyTypes.GETSUBSCRIPTIONREPORTS_FAILURE]: getsubscriptionreportsFailure,

    [CompanyTypes.GETSUBSCRIPTIONFREQUENCIES_REQUEST]: getsubscriptionfrequenciesRequest,
    [CompanyTypes.GETSUBSCRIPTIONFREQUENCIES_SUCCESS]: getsubscriptionfrequenciesSuccess,
    [CompanyTypes.GETSUBSCRIPTIONFREQUENCIES_FAILURE]: getsubscriptionfrequenciesFailure,

    [CompanyTypes.POSTADDSUBSCRIPTION_REQUEST]: postaddsubscriptionRequest,
    [CompanyTypes.POSTADDSUBSCRIPTION_SUCCESS]: postaddsubscriptionSuccess,
    [CompanyTypes.POSTADDSUBSCRIPTION_FAILURE]: postaddsubscriptionFailure,

    [CompanyTypes.POSTSAVESUBSCRIPTION_REQUEST]: postsavesubscriptionRequest,
    [CompanyTypes.POSTSAVESUBSCRIPTION_SUCCESS]: postsavesubscriptionSuccess,
    [CompanyTypes.POSTSAVESUBSCRIPTION_FAILURE]: postsavesubscriptionFailure,

    [CompanyTypes.SETBZCOMPANY_REQUEST]: setbzcompanyRequest,

    [CompanyTypes.RESET_REQUEST]: resetRequest,

    [CompanyTypes.CLEAR_REQUEST]: clearRequest,
});
